<template>
  <span class="badge text-wrap" :style="`color: ${textColor}; background-color: ${bgColor}`">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    bgColor: {
      type: String,
      required: false,
      default: '#e9ffa8',
    },
    textColor: {
      type: String,
      required: false,
      default: 'black',
    },
  },
}
</script>

<style lang="scss" scoped></style>
